module.exports = __webpack_public_path__ + "media/images/powered-by-stripe-9e33ce5244b4cfe6ecc3b729642082f9.svg";